<template>
  <div :style="hideDetails && 'border: 1px solid rgba(0, 0, 0, 0.12)'" class="rounded-lg">
    <template v-if="!hideDetails">
      <!-- Date header -->
      <p class="text-center subtitle-1 font-weight-bold mb-3">
        {{
          localeDate(currentMenuDate, {
            weekday: "long",
          })
        }},
        {{ localeDate(currentMenuDate) }}
      </p>

      <!-- Shift name with lines -->
      <div class="d-flex align-center mb-4">
        <v-divider class="flex-grow-1"></v-divider>
        <span class="mx-3 text-body-2 font-weight-medium">{{ shiftName }}</span>
        <v-divider class="flex-grow-1"></v-divider>
      </div>
    </template>

    <v-row>
      <v-col cols="4">
        <v-img :src="mealImage" aspect-ratio="1" class="rounded-lg"></v-img>
      </v-col>
      <v-col cols="8">
        <v-row no-gutters class="flex-column fill-height py-2" justify="space-between">
          <div>
            <h3 class="text-h6 font-weight-bold mb-2">
              {{ meal.name }}
            </h3>

            <p class="text-body-2 mb-3" v-if="meal.description">
              {{ meal.description }}
            </p>

            <!-- Tag (if applicable) -->
            <v-chip v-if="meal.type" class="mb-3" small color="grey lighten-3">
              {{ meal.type }}
            </v-chip>

            <div
              v-if="showPrice && meal.price"
              class="text-body-2 font-weight-medium mt-1"
            >
              <span class="primary--text">{{ meal.price }}</span> KM
            </div>
          </div>

          <div>
            <v-row align="center" no-gutters v-if="!disabled">
              <div class="quantity-controls">
                <v-btn
                  v-if="!isDisabledCard"
                  icon
                  small
                  :color="isDisabledCard || quantity <= 0 ? 'grey lighten-2' : 'primary'"
                  :disabled="isDisabledCard || quantity <= 0"
                  @click="updateQuantity(-1)"
                  class="quantity-btn"
                >
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>

                <span class="quantity-text mx-2">{{ quantity }}</span>

                <v-btn
                  v-if="!isDisabledCard"
                  icon
                  small
                  :color="isDisabledCard ? 'grey lighten-2' : 'primary'"
                  :disabled="isDisabledCard"
                  @click="updateQuantity(1)"
                  class="quantity-btn"
                >
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </div>
            </v-row>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import hasMenuOrdering from "@/mixins/hasMenuOrdering";
export default {
  props: {
    meal: {
      type: Object,
      required: true,
    },
    dailyMenu: {
      type: Object,
      required: true,
    },
    shift: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [hasMenuOrdering],
  computed: {
    showPrice() {
      const company = this.$store.state.company;
      if (!company.settings) return false;
      const settings = JSON.parse(company.settings);
      return !!settings?.show_price;
    },
    shiftName() {
      const shifts = this.shift.split("-");
      let code = null;
      if (shifts) {
        code = "shift_" + shifts[0];
      }
      const translation = (this.$store.state.company?.shift_translations || []).find(
        (st) => {
          return st.shift_code === code && st.language_code === this.$i18n.locale;
        }
      );
      return translation?.label || this.$t(code) || code || this.shift;
    },
    currentMenuDate() {
      return this.$store.state.companyMenu.currentMenuDate;
    },
  },
};
</script>

<style scoped>
.quantity-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 24px;
}

.quantity-btn {
  background: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.quantity-btn:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.quantity-text {
  font-weight: 700;
  font-size: 1.2rem;
  min-width: 30px;
  text-align: center;
  color: #1a1a1a;
}
</style>
